module.exports = __webpack_public_path__ + "static/media/ad-demand-prioritization-icon.48b2e868.svg";